// Tracking for Heap
export const HEAP_PAGE_AREA = 'category-browse';
export const HEAP_TRACKABLE_EVENT = 'DiscoverComponentView';
